import { Alert, Button, CircularProgress, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { generatePath, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../main/hooks/hooks';
import { selectGraphReadyQueue, selectGraphSaving, shiftGraphReady } from '../../../main/slices/utilSlice';
import ROUTES from '../../constants/routeConstants';

const MAX_NAME_LENGTH = 25;

const truncate = (name: string): string =>
    name.length > MAX_NAME_LENGTH ? `${name.slice(0, MAX_NAME_LENGTH)}…` : name;

const GraphStatusSnackbar = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const graphSaving = useAppSelector(selectGraphSaving);
    const graphReadyQueue = useAppSelector(selectGraphReadyQueue);

    const nextReady = graphReadyQueue[0];

    const handleViewReady = () => {
        if (nextReady) {
            const path = generatePath(ROUTES.GRAPH, { entityId: nextReady.correlationId, entityType: nextReady.entityType });
            navigate(path);
            dispatch(shiftGraphReady());
        }
    };

    const handleDismissReady = () => {
        dispatch(shiftGraphReady());
    };

    const savingMessage = graphSaving.length === 1
        ? `Graph "${truncate(graphSaving[0].name)}" is saving. Please wait.`
        : `${graphSaving.length} graphs are saving. Please wait.`;

    return (
        <>
            <Snackbar open={graphSaving.length > 0} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                <Alert severity="info" icon={<CircularProgress size={20} color="inherit" />} variant="filled" style={{ alignItems: 'center' }}>
                    {savingMessage}
                </Alert>
            </Snackbar>
            <Snackbar
                open={!!nextReady}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                onClose={(_, reason) => { if (reason !== 'clickaway') handleDismissReady(); }}
            >
                <Alert
                    severity="success"
                    variant="filled"
                    action={
                        <>
                            <Button color="inherit" size="small" onClick={handleViewReady}>
                                View Now
                            </Button>
                            <IconButton size="small" color="inherit" onClick={handleDismissReady} aria-label="close">
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </>
                    }
                >
                    Graph "{nextReady ? truncate(nextReady.name) : ''}" saved!
                </Alert>
            </Snackbar>
        </>
    );
};

export default GraphStatusSnackbar;
